import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';

@Injectable()
export class TaskReviseService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public reviseTask(taskId: string): Observable<void> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/revise`;

    return this.client.post<void>(url, {}).pipe(
      catchError(error => throwError(() => handleProblem(error)))
    );
  }
}
